import { DateTime } from 'luxon';
import { mapActions, mapGetters } from 'vuex';

const ISODateStr = new Date().toISOString();
const luxonDate = DateTime.fromISO(ISODateStr);
const today = luxonDate.toFormat('yyyy-MM-dd', { locale: "es" });
// const oneMonthAgo = luxonDate.minus({ days: 30 }).endOf('day').toFormat('yyyy-MM-dd', { locale: "es" });
const last7days = luxonDate.minus({ days: 7 }).endOf('day').toFormat('yyyy-MM-dd', { locale: "es" });
// const isPendientes = this.context == "POR_LAVAR"
//   || this.context == "POR_DOBLAR" || this.context == "TERMINADAS"
//   || this.context == "TODAS";

export default {
  data: () => ({
    dates: [last7days, today],
    singleDate: [today],
    startTime: "00:00:00",
    endTime: "23:59:59",
    loadingTableData: false,
  }),
  computed: {
    ...mapGetters(["datePickerModalContext"]),
    dateRangeText() {
      const dates = this.isPendientesContext ? this.singleDate : this.dates;
      const formatedDates = dates.map(dateStr => DateTime.fromFormat(dateStr, 'yyyy-MM-dd')
        .toFormat('ccc d LLL y', { locale: "es" }))
      return formatedDates.join(" ~ ");
    },
    isPendientesContext() {
      const isPendientes = this.context == "POR_LAVAR"
        || this.context == "POR_DOBLAR" || this.context == "TERMINADAS"
        || this.context == "TODAS";
      return isPendientes;
    },
    selectedDates: {
      get: function () {
        return this.isPendientesContext ? this.singleDate : this.dates;
      },
      set: function (dates) {
        if (this.isPendientesContext) {
          this.singleDate = dates;
        }
        else this.dates = dates;
      },
    },
    showTableLoadingMsg: {
      get: function () {
        return this.loadingTableData;
      },
      set: function (isLoading) {
        this.loadingTableData = isLoading;
      },
    },
  },
  methods: {
    ...mapActions(['showNavDatePickerModal', "changeDatePickerModalContext"]),
    openDatePickerModal(context) {
      if (context && this.datePickerModalContext === "GLOBAL") {
        this.showNavDatePickerModal(true);
        this.changeDatePickerModalContext(this.context);
      }
    },
  },
}